import { useEffect, useState } from 'react';

// useState backed by localStorage, or sessionStorage (this browser tab only) with storage =
// 'session'. Keys are campsez.reports.<campCode>.*, so a super director's settings stay with the
// camp they were made in. A null key keeps the value in memory only.
const storageFor = kind => (kind === 'session' ? window.sessionStorage : window.localStorage);

export function hasStoredValue(key, storage = 'local') {
  if (!key) return false;
  try {
    return storageFor(storage).getItem(key) !== null;
  } catch {
    return false;
  }
}

export function usePersistentState(key, initial, storage = 'local') {
  const [value, setValue] = useState(() => {
    if (!key) return initial;
    try {
      const raw = storageFor(storage).getItem(key);
      return raw ? JSON.parse(raw) : initial;
    } catch {
      return initial;
    }
  });

  useEffect(() => {
    if (!key) return;
    try {
      storageFor(storage).setItem(key, JSON.stringify(value));
    } catch {
      // Storage unavailable (private mode, quota): settings simply won't persist.
    }
  }, [key, value, storage]);

  return [value, setValue];
}
